import { isPhone } from './device';

let fbUserInfo = {
  id: '',
  name: '',
  avatar: ''
};

export const facebookShare = function(href) {
  let curUrl = window.globalGetGotoLink({
    link: href + '&cid=gameshare&scid=fbshare'
  });
  getFbLoginStatus().then((res) => {
    if (res) {
      doShare(curUrl);
    } else {
      fbLogin().then(
        () => {
          doShare();
        },
        () => {
          console.log('登录失败');
        }
      );
    }
  });
};

export const twiShare = function(text, href) {
  let curUrl = window.globalGetGotoLink({
    link: href + '&cid=gameshare&scid=twishare'
  });
  var url = `//twitter.com/intent/tweet?text=${encodeURIComponent(
    text || ''
  )} ${encodeURIComponent(curUrl)}`;
  window.open(url);
};

export const lineShare = function(href) {
  let curUrl = window.globalGetGotoLink({
    link: href + '&cid=gameshare&scid=lineshare'
  });
  // if (isPhone()) {
  //     window.open(`line://msg/text/${encodeURIComponent(href+'&cid=gameshare&scid=lineshare')}`, "_blank", "toolbar=yes,location=yes,directories=no,status=no,menubar=yes,scrollbars=yes,resizable=no,copyhistory=yes");
  // } else {
  window.open(
    `https://lineit.line.me/share/ui?url=${encodeURIComponent(curUrl)}`,
    '_blank',
    'toolbar=yes,location=yes,directories=no,status=no,menubar=yes,scrollbars=yes,resizable=no,copyhistory=yes'
  );
  // }
};

export const fbPay = function(appId, order_id) {
  return new Promise((resolve, reject) => {
    FB.ui(
      {
        method: 'pay',
        action: 'purchaseitem',
        product: `https://jpstore.37games.com/facebook_local_money/product_items/app_id/${appId}/order_id/${order_id}`,
        request_id: order_id
      },
      (res) => {
        if (res && !res['error_code']) {
          resolve(res);
        } else {
          reject(res);
        }
      }
    );
  });
};

const getFbLoginStatus = function() {
  return new Promise((resolve, reject) => {
    FB.getLoginStatus((response) => {
      resolve(response.status === 'connected');
    }, true);
  });
};

const getFbUserInfo = function() {
  return new Promise((resolve) => {
    FB.api('/me', (response) => {
      fbUserInfo = {
        id: response.id,
        name: response.name,
        avatar: `https://graph.facebook.com/${response.id}/picture`
      };
      resolve(fbUserInfo);
    });
  });
};

const fbLogin = function() {
  return new Promise((resolve, reject) => {
    FB.login((response) => {
      if (response.authResponse) {
        resolve(response);
      } else {
        reject();
      }
    });
  });
};

const fbShare = function(href) {
  return new Promise((resolve, reject) => {
    FB.ui(
      {
        method: 'share',
        href: href
      },
      function(response) {
        resolve(response && !response.error_message);
      }
    );
  });
};

const doShare = function(href) {
  getFbUserInfo();
  fbShare(href).then((res) => {
    console.log(res);
  });
};
